import {
  authHeader,
  handleResponse,
  errorOnActivation,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Region
function getLimitedReleaseByVirtual(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createLimitedReleaseByVirtual(requestBody, queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editLimitedReleaseByVirtual(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteLimitedReleaseByVirtual(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function activateLimitedReleaseByVirtual(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/activate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(errorOnActivation)
    .then((data) => {
      return data;
    });
}

function deactivateLimitedReleaseByVirtual(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/deactivate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const limitedReleasesVirtualService = {
  getLimitedReleaseByVirtual,
  createLimitedReleaseByVirtual,
  editLimitedReleaseByVirtual,
  deleteLimitedReleaseByVirtual,
  activateLimitedReleaseByVirtual,
  deactivateLimitedReleaseByVirtual,
};
